import { actionFactory, typeFactory } from 'common/store/scope';

export const SEARCH = 'SEARCH';
export const ADVANCED_SEARCH = 'ADVANCED_SEARCH';

export const search = query => ({
  type: SEARCH,
  query,
});

export const advancedSearch = criteria => ({
  type: ADVANCED_SEARCH,
  criteria,
});

export const factory = namespace => ({
  ...actionFactory(namespace, {
    search,
    advancedSearch,
  }),
  TYPES: typeFactory(namespace, {
    SEARCH,
    ADVANCED_SEARCH,
  }),
});

export default factory;
